import { Component, OnInit, Inject, HostListener, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { SignupService, AlertService } from '@app/_services';
import { Package } from '../../_models/package';
import { Signup } from '@app/_models';
import { SignupComponent } from '../signup.component';
import { breakpointPixels, FadvTypographyComponent } from '@fa-switch-sharedservices/ng-elements';
import { Order, Product } from '@app/_models/orders/shared';
import { buildAddOnForm, getSelectedProductIDs, hasAddOnProducts } from '@app/_helpers';

// declare var bootstrapChat: Function;
// declare var sfchat: Function;

@Component({
  selector: 'app-package',
  templateUrl: './package.component.html',
  styleUrls: ['./package.component.less']
})

export class PackageComponent implements OnInit {

  form: UntypedFormGroup;
  addOnForm: UntypedFormGroup;
  loading = false;
  submitted = false;
  signup: Signup;
  packages: Package[];
  backButtonAlignment: string = 'right';
  nextButtonAlignment: string = 'left';
  innerWidth: number;
  products: Product[] = [];
  noCredCheckProducts: Product[] = [];
  hideDlProduct: boolean = false;
  breakpoints = breakpointPixels;
  hasAddOnProduct: boolean = false;
  @ViewChild('header') header!: FadvTypographyComponent;


  constructor(private formBuilder: UntypedFormBuilder,
    private router: Router,
    private signupService: SignupService,
    private alertService: AlertService,
     @Inject(SignupComponent) private signupComponent: SignupComponent) {
    this.innerWidth = window.innerWidth;
    this.handleViewChange();
    // sfchat(true);
  }


  ngAfterViewInit(): void {
    this.signupComponent.setStep(this.router.url)
  }

  @HostListener('window:resize', ['$event'])

  onResize(event) {
    this.innerWidth = window.innerWidth;
    this.handleViewChange();
  }

  handleViewChange(): void {
    if (this.innerWidth <= breakpointPixels.md) {
      this.backButtonAlignment = 'center';
      this.nextButtonAlignment = 'center';
    } else {
      this.backButtonAlignment = 'right';
      this.nextButtonAlignment = 'left';
    }
  }
  ngOnInit() {
    // sfchat(true);

    //this.signupComponent.setStep(this.router.url)
    this.signup = this.signupService.getSignup();
    if (this.signup.order == undefined) {
      this.signup.order = new Order();
    }

    this.form = this.formBuilder.group({
      packageID: ['']
    });

    this.signupService.getPackageTemplates().subscribe(data => this.handlePackages(data));

    this.getAlaCarteProducts();

    if (this.signup.packageID != undefined) {
      this.form.patchValue({ packageID: this.signup.packageID });
    }
  }

  handlePackages(data: Package[]) {
    var description = " - Tier " + this.signup.partnerTierID;
    var faTag = "FA ";
    data.forEach(x => {
      x.description = x.description.replace(description, '');
      x.productDescriptions.forEach(i => {
        i.descriptionFA = i.descriptionFA.replace(faTag, '');
      })
      if (this.signup.packageGuids.indexOf(x.id) === -1) {
        this.signup.packageGuids.push(x.id);
      }
    })
    this.packages = data;
  }

  get f() { return this.form.controls; }

  selectPackage(id: string) {
    this.alertService.clear();
    if (this.form.value.packageID === id) {
      this.form.patchValue({ packageID: '' });
    } else {
      this.form.patchValue({ packageID: id });
    }
    this.toggleDLProduct(id);
  }

  onCancel() {

    // sfchat(false);
    this.signupComponent.signUpStepper.previousStep();
    this.router.navigate(['/signup/start'])


  }

  onSubmit() {
    this.submitted = true;

    this.addProductIDs();

    if (!this.form.value.packageID && this.signup.order.addOnProducts.length === 0) {
      this.alertService.error("Please select a package or product.", { autoClose: false })
      return;
    }

    this.signup.packageID = this.form.value.packageID;
    this.signup.package = this.packages.find(x => x.id === this.form.value.packageID);
    this.signup.skipSignUp = false;

    this.signupService.savePackage(this.signup);
    this.signupComponent.signUpStepper.nextStep()
    this.signupComponent.packageStep.visited = true;
    // sfchat(false);
    this.router.navigate(['/signup/candidate']);
  }

  getAlaCarteProducts(): void {
    this.addOnForm = this.formBuilder.group({})
    this.signupService.getALaCarteProducts(0).subscribe(products => {
      this.products = products;
      // if the product is the credit check product, delete it from the array
      this.products.forEach((product, index) => {
        if (product.id === 296) {
          delete this.products[index];
        }
      })

      //populate the array of noCredCheckProducts with the members of products so no null value is passed
      //to the buildAddOnForm method
      this.products.forEach((product, index) => {
        if (product != null) {
          this.noCredCheckProducts[index] = this.products[index];
        }
      })

      buildAddOnForm(this.noCredCheckProducts, this.signup.order.addOnProducts, this.addOnForm);
    })
  }

  handleProductCheckbox(checked: boolean, id: number) {
    this.hasAddOnProduct = hasAddOnProducts(this.addOnForm, id, checked);
  }

  addProductIDs(): void {
    this.signup.order.addOnProducts.length = 0;
    this.signup.order.addOnProducts.push(...getSelectedProductIDs(this.addOnForm));
  }

  toggleDLProduct(id: string): void {
    var pack = this.packages.find(x => x.id === id);
    this.hideDlProduct = pack?.dlRequired && id === this.form.value.packageID;
    if (this.hideDlProduct) {
      var dl = this.products.find(x => x.description == "Drivers License" || x.description == "FA Drivers License").id.toString();
      this.addOnForm.controls[dl].setValue(false);
    }
  }

  hideCreditCheckProduct(id: string): void {
    var pack = this.packages.find(x => x.id === id);
    this.hideDlProduct = pack?.dlRequired && id === this.form.value.packageID;
    if (this.hideDlProduct) {
      var dl = this.products.find(x => x.description === "Drivers License").id.toString();
      this.addOnForm.controls[dl].setValue(false);
    }
  }

  skipToAccount() {
    // sfchat(false);
    this.signup.packageID = this.form.value.packageID;
    this.signup.skipSignUp = true;
    this.signupService.savePackage(this.signup);
    this.router.navigate(['/signup/account']);
  }
  contactUs() {
    this.signupService.forwardClient(this.signup).subscribe(x => {
      //leaving this in case they tell me to manipulate the returned hubspot data somehow cb
      if (x) {


      }
    });;
    this.router.navigate(['/signup/contact'])
  }
}
